import { url } from "./misc";
import Cookies from 'js-cookie';

export async function Auth(tenant) {
    const endpoint = url + "/api/zpa/authentication"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'tenant': tenant,
            'JWT': JWT
        },
        body: JSON.stringify(requestData),
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

};

export async function ListAppSegments(access_token, tenant) {
    const endpoint = url + "/api/zpa/appsegments/list";
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'access_token': access_token,
            'tenant': tenant,
            'JWT': JWT
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response

}

export async function ListAppConnectorGroups(access_token, tenant) {
    const endpoint = url + "/api/zpa/appconnectorgroups/list";
    const JWT = Cookies.get('CF_Authorization');

    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'access_token': access_token,
            'tenant': tenant
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response

}

export async function UpdateAppSegment(app_segment, description, replacePortRanges, access_token, tenant) {
    const endpoint = url + "/api/zpa/appsegments/update";
    const JWT = Cookies.get('CF_Authorization');

    // Define the request parameters
    const requestData = app_segment;

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'description': description,
            'access_token': access_token,
            'tenant': tenant,
            'replaceportRanges': replacePortRanges
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

}

export async function UpdateAppConnectorGroup(app_connector_group, description, access_token, tenant) {
    const endpoint = url + "/api/zpa/appconnectorgroups/update";
    const JWT = Cookies.get('CF_Authorization');

    // Define the request parameters
    const requestData = app_connector_group;

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'access_token': access_token,
            'tenant': tenant,
            'description': description
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

}


export async function SignOut(access_token) {
    const endpoint = url + "/api/zpa/signout";
    const JWT = Cookies.get('CF_Authorization');

    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'access_token': access_token
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

}

export async function ListIDPs(tenant, access_token) {
    const endpoint = url + "/api/zpa/idps/list";
    const JWT = Cookies.get('CF_Authorization');

    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'access_token': access_token,
            'tenant': tenant
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

}

export async function ListScimGroups(tenant, idp_id, access_token) {
    const endpoint = url + "/api/zpa/scimgroups/list";
    const JWT = Cookies.get('CF_Authorization');

    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'access_token': access_token,
            'tenant': tenant,
            'idp_id': idp_id
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

}

